import React, {  Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';

class PriceSourceOverlayDialog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showDialog: false,
			selectedPriceSource: null
        }
    }
    closeDialog(event) {
        event.preventDefault();
        this.setState({
            showDialog: false
        });
		this.props.handleDialog && this.props.handleDialog('PriceSourceOverlayDialog', false);
    }
    componentDidMount() {
		// window.scrollTo(0, 0);
        this.setState({
            showDialog: this.props.showDialog,
			selectedPriceSource: this.props.user.allSelectedAccountsAllPriceSources.find(item => item.AGREEMENT_NUMBER === parseInt(this.props.priceSource, 10))
        });
    }
    render() {
		const self = this;
		const { selectedItem } = self.props;
		let pricingData = null;
		let discountDetails = null;
		if(selectedItem.redirectFrom === 'order' || selectedItem.redirectFrom === 'manageorder' || selectedItem.redirectFrom === "quickorder" || selectedItem.redirectFrom === "updatebookedorder") {
			pricingData = self.props.order.prices.find(itm => itm.item_number === selectedItem.item);
		} else {
			pricingData = self.props.cart.prices.find(itm => itm.item_number === selectedItem.item);
		}
		if(pricingData && pricingData.records && pricingData.records.length>0 ) {
			// get 5 discounts and update object
			let priceRecordForDiscounts = JSON.parse(JSON.stringify(pricingData.records));
			const unitPrice = priceRecordForDiscounts[0].unit_price ? priceRecordForDiscounts[0].unit_price : '',
				adjUnitPrice = priceRecordForDiscounts[0].adjusted_unit_price ? priceRecordForDiscounts[0].adjusted_unit_price : '';
			if(pricingData.records[0].dtl_stg_operand_calc_code === 'NEWPRICE') {
				priceRecordForDiscounts = [];
				pricingData.records.forEach((it, indx) => {
					if(indx !== 0) {
						priceRecordForDiscounts.push(it);
					}
				});
			}
			let pts = _.find(priceRecordForDiscounts, { 'modifier_price_subtype': 'DFI - PLAN TO SELL' });
			pts = pts ? pts.dtl_stg_adjusted_amt : '';
			priceRecordForDiscounts = _.pullAllBy(priceRecordForDiscounts, [{ 'modifier_price_subtype': 'DFI - PLAN TO SELL' }], 'modifier_price_subtype');

			let groupPA = _.find(priceRecordForDiscounts, { 'modifier_price_subtype': 'DFI - GROUP PRICE ADJUSTMENT' });
			groupPA = groupPA ? groupPA.dtl_stg_adjusted_amt : '';
			priceRecordForDiscounts = _.pullAllBy(priceRecordForDiscounts, [{ 'modifier_price_subtype': 'DFI - GROUP PRICE ADJUSTMENT' }], 'modifier_price_subtype');

			let draft = _.find(priceRecordForDiscounts, { 'modifier_price_subtype': 'DFI - DRAFT' });
			draft = draft ? draft.dtl_stg_adjusted_amt : '';
			priceRecordForDiscounts = _.pullAllBy(priceRecordForDiscounts, [{ 'modifier_price_subtype': 'DFI - DRAFT' }], 'modifier_price_subtype');

			let pvr = _.find(priceRecordForDiscounts, { 'modifier_price_subtype': 'DFI - VOLUME REBATE' });
			pvr = pvr ? pvr.dtl_stg_adjusted_amt : '';
			priceRecordForDiscounts = _.pullAllBy(priceRecordForDiscounts, [{ 'modifier_price_subtype': 'DFI - VOLUME REBATE' }], 'modifier_price_subtype');

			let other = 0;
			priceRecordForDiscounts.forEach(itm => {
				if(itm.dtl_stg_adjusted_amt) {
					other += parseFloat(itm.dtl_stg_adjusted_amt);
				}
			});
			discountDetails = {
				price: unitPrice ? unitPrice.replace("-","") : "",
				netPrice: adjUnitPrice ? adjUnitPrice.replace("-","") : "",
				pts: pts ? pts.replace("-","") : "",
				groupPA: groupPA ? groupPA.replace("-","") : "",
				other: other === 0 ? '' : other.toString().replace("-",""),
				draft: draft ? draft.replace("-","") : "",
				pvr: pvr ? pvr.replace("-","") : "",
			};
		}
		const isPricingAccess = self.props.isResponsibilityExists("Price");
        return (
            <div className={"overlayDialog "+(this.state.showDialog?"visible":"hide")} id="showPriceSourceOverlayDialog">
                <div className="blackoutLayer"></div>
                <div className="overlayDialogWindow">
                    <a className="closeButton" onClick={this.closeDialog.bind(this)}>×</a>
                    <h2 className="title">PRICE INFO</h2>
					{this.state.selectedPriceSource &&
                    	<p><b>Sales Agreement:</b> {this.state.selectedPriceSource.AGREEMENT_NAME}</p>
					}
					<p><b>Price Date:</b> {selectedItem && selectedItem.pricingDate ? selectedItem.pricingDate : this.props.orderDate}</p>
                    {selectedItem.redirectFrom === "backorders" &&
                        <p><b>Today's Price</b>: {self.props.formatMoney(selectedItem.todaysPrice, 0, ".", ",", false, "$")}</p>}
                    {selectedItem.redirectFrom === "updatebookedorder" &&
                        <p><b>Net Price</b>: {self.props.formatMoney(selectedItem.price, 0, ".", ",", false, "$")}</p>}
					{isPricingAccess && discountDetails && (discountDetails.pts || discountDetails.groupPA || discountDetails.other || discountDetails.draft || discountDetails.pvr) &&
						<div>
							<hr />
							<table width="100%">
								<tbody>
									<tr>
										<td>Price (each)</td>
										<td className="text-right">{self.props.formatMoney(discountDetails.price, 0, ".", ",", false, "")}</td>
									</tr>
									{discountDetails.pts ? <tr>
										<td> &nbsp; &nbsp; PTS</td>
										<td className="text-right">{self.props.formatMoney(discountDetails.pts * -1, 0, ".", ",", false, "")}</td>
									</tr> : null}
									{discountDetails.groupPA ? <tr>
										<td> &nbsp; &nbsp; Group PA</td>
										<td className="text-right">{self.props.formatMoney(discountDetails.groupPA * -1, 0, ".", ",", false, "")}</td>
									</tr> : null}
									{discountDetails.draft ? <tr>
										<td> &nbsp; &nbsp; Draft</td>
										<td className="text-right">{self.props.formatMoney(discountDetails.draft * -1, 0, ".", ",", false, "")}</td>
									</tr> : null}
									{discountDetails.pvr ? <tr>
										<td> &nbsp; &nbsp; VR</td>
										<td className="text-right">{self.props.formatMoney(discountDetails.pvr * -1, 0, ".", ",", false, "")}</td>
									</tr> : null}
									{discountDetails.other ? <tr>
										<td> &nbsp; &nbsp; Other</td>
										<td className="text-right">{self.props.formatMoney(discountDetails.other * -1, 0, ".", ",", false, "")}</td>
									</tr> : null}
									<tr>
										<td>
											<b>Net Price (each)</b>
										</td>
										<td className="text-right">
											<b>{self.props.formatMoney(discountDetails.netPrice, 0, ".", ",", false, "$")}</b>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					}
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
	return {
		order: state.order,
		cart: state.cart,
        user: state.user,
	};
};

PriceSourceOverlayDialog = connect(mapStateToProps)(PriceSourceOverlayDialog);
export default PriceSourceOverlayDialog;



// WEBPACK FOOTER //
// ./src/App/components/dialogs/priceSourceOverlayDialog.js